export class OfferPageError extends Error {
    constructor(...params) {
        super(...params);
        this.name = "OfferPageError"
    }
}

export class PageFreemiumError extends Error {
    constructor(...params) {
        super(...params);
        this.name = "PageFreemiumError"
    }
}

export class LandingPageError extends Error {
    constructor(...params) {
        super(...params);
        this.name = "LandingPageError"
    }
}

export class AuthHelperError extends Error {
    constructor(...params) {
        super(...params);
        this.name = "AuthHelperError"
    }
}